import { DAYJS_FORMAT } from "~/const-files/const";
import { getCalendar } from "./php-api";
import { IGoogleCalendarItem } from "~/interfaces";
import { getCurrentMonday } from "~/utils/utils";

let googleCalendarEvents: Array<IGoogleCalendarItem> = [];
const URL_REGEX = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/ug;

export async function loadCalendar(isAdmin: boolean) {
	if (isAdmin) {
		const monday = getCurrentMonday();
		const data = await getCalendar(monday.format(DAYJS_FORMAT));

		if (data.data) {
			for (const item of data.data) {
				item.summary = item.summary.replace(URL_REGEX, "");
			}

			// odstranime url
			googleCalendarEvents = data.data;
		}
	}

	return Promise.resolve({});
}

export function getGoogleCalendarEvents() {
	return googleCalendarEvents;
}
